'use strict';

var HorizontalScrollSnap = require('../components/HorizontalScrollSnap.js');

var IS_ACTIVE_CLASS_NAME = 'isActive';
var IS_IN_VIEW_CLASS_NAME = 'isInView';

/**
 * @class
 */
var GallerySection = function(sectionElement) {
	this._sectionElement = sectionElement;
	
	this._onActiveChange = this._onActiveChange.bind(this);
	this._onInViewChange = this._onInViewChange.bind(this);
	this._onClickOfBulletControl = this._onClickOfBulletControl.bind(this);
	
	// Create horizontal scroll with snapping
	this._horizontalScrollSnap = new HorizontalScrollSnap({
		elements : {
			listenForEvents : sectionElement.querySelector('.gallerySection__scroll'),
			move : sectionElement.querySelector('.gallerySection__itemContainer'),
			viewport : sectionElement.querySelector('.gallerySection__browserBg'),
			contentSize : sectionElement.querySelector('.gallerySection__itemContainer')
		},
		snap : {
			elements : sectionElement.querySelectorAll('.gallery__item'),
			leftEdges : false,
			rightEdges : false,
			centers : true
		},
		listeners : {
			activeChange : this._onActiveChange,
			inViewChange : this._onInViewChange
		}
	});
	this._horizontalScrollSnap.start();
	
	// Setup bullet controls
	this._bulletControlElements = sectionElement.querySelectorAll('.bulletControl');
	for (var x=0; x < this._bulletControlElements.length; x++) {
		this._bulletControlElements[x].addEventListener('click', this._onClickOfBulletControl, false);
	}
}

GallerySection.COMPONENT_STYLE_CLASS = 'gallerySection';

/**
 * @private
 */
GallerySection.prototype._onActiveChange = function(event, data) {
	var previous = data.previous,
		active = data.active;
	if (active !== null) {
		active.element.classList.add(IS_ACTIVE_CLASS_NAME);
	}
}

/**
 * @private
 */
GallerySection.prototype._onInViewChange = function (event, data) {
	var inViewChangeData, i, bulletElement;
	
	for (i=0; i < data.length; i++) {
		inViewChangeData = data[i];
		bulletElement = this._bulletControlElements[inViewChangeData.index];
		
		if (inViewChangeData.cover > 0) {
			inViewChangeData.element.classList.add(IS_IN_VIEW_CLASS_NAME);
			
			// Adjust the bullets
			if (bulletElement !== undefined) {
				bulletElement.classList.add(IS_IN_VIEW_CLASS_NAME);
				
				var bulletFill = bulletElement.children[0].children[0];

				// The left and right are swapped on purpose on the next two lines.
				bulletFill.style.right = Math.round(inViewChangeData.left * 100) + '%';
				bulletFill.style.left = Math.round(inViewChangeData.right * 100) + '%';
			}
			
		} else {
			inViewChangeData.element.classList.remove(IS_IN_VIEW_CLASS_NAME);
			inViewChangeData.element.classList.remove(IS_ACTIVE_CLASS_NAME);
			
			// Adjust the bullets
			if (bulletElement !== undefined) {
				bulletElement.classList.remove(IS_IN_VIEW_CLASS_NAME);
			}
			
		}
		
		
	}
}

/**
 * @private
 */
GallerySection.prototype._onClickOfBulletControl = function(event) {
	event.preventDefault();
	this._horizontalScrollSnap.animateTo(event.currentTarget.dataset.index);
}

module.exports = GallerySection;

